import MyRequests from '@/pages/MyRequests';

export default [
  {
    path: '/requests',
    component: MyRequests,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'requests.index',
        redirect: { name: 'requests.timesheet' },
      },
      {
        path: 'overtime',
        name: 'requests.ot',
        meta: {
          type: 'overtime',
          permissions: ['perm_view_own_overtime'],
        },
      },
      {
        path: 'ob',
        name: 'requests.ob',
        meta: {
          type: 'ob',
          permissions: ['perm_view_own_ob'],
        },
      },
      {
        path: 'timesheet',
        name: 'requests.timesheet',
        meta: {
          type: 'timesheet',
          permissions: ['perm_view_own_timesheet'],
        },
      },
    ],
  },
];
